<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      scrollable
      transition="dialog-top-transition"
      max-width="550px"
    >
      <v-card>
        <div class="container-comfirm">
          <div class="my-10">
            <h3>ยืนยันการลบ</h3>
          </div>
          <div class="d-flex justify-content-between">
            <v-btn class="btn-checklist" @click="$emit('close')">ยกเลิก</v-btn>
            <v-btn class="btn-submit" @click="$emit('submit', id)">ยืนยัน</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ['dialog', 'id']
}
</script>

<style lang="scss" scoped>
.container-comfirm {
  justify-content: center;
  margin: 30px 25px;
  display: flex;
  flex-direction: column;
  text-align: center;
}
</style>
